import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_secured/external-data/import-hub/single-platform',
)({
  beforeLoad() {
    throw redirect({ to: '/external-data/import-hub/performance' });
  },
});
